/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'air_type': {
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M5.84 7.012l-.615.476a.394.394 0 0 1-.556-.072.4.4 0 0 1 .072-.56l.721-.559a.392.392 0 0 1 .242-.083h2.61c.094 0 .186.035.259.097l.642.56a.402.402 0 0 1 .041.562.396.396 0 0 1-.56.042l-.53-.463H5.838zM8.845 8.44L12.6 9.555V8.83a.624.624 0 0 0-.245-.497l-4.28-3.265c-.044-.042 0-.383 0-.442v-.928c0-.585.174-1.415-.235-1.868-.854-.946-1.915-.184-1.915.858v2.07a.625.625 0 0 1-.245.497L1.645 8.333a.625.625 0 0 0-.245.497v.725L5.153 8.44a.62.62 0 0 1 .795.598v.63c0 .26-.092.511-.259.709l-.8.95a.627.627 0 0 0-.147.402v.87l2.244-1.19h.028l2.243 1.19v-.87a.627.627 0 0 0-.146-.403l-.8-.95a1.097 1.097 0 0 1-.259-.707v-.631a.62.62 0 0 1 .794-.598z" _fill="#000"/>'
  }
})
